import {useUiFlag} from "state/hooks";
import {FLAG_SESSION_FLOATING, FLAG_SESSION_ID, FLAG_SESSION_PENDING} from "joynt/config";

export function useIsSessionView() {
    const [isSession] = useUiFlag(FLAG_SESSION_ID);
    const [isFloating] = useUiFlag(FLAG_SESSION_FLOATING);
    const [isPending] = useUiFlag(FLAG_SESSION_PENDING);

    return !!((isSession && !isFloating) || isPending);
}